/* Qty Breaks — externalized from snippets/qty-breaks.liquid (logic unchanged).
   Per-page data (default variant id, variant map) comes from the JSON config
   block <script type="application/json" data-qty-breaks-config> rendered by the
   snippet. Requires sneak-money.js for price formatting. */
(function() {
  if (window.__sneakQtyBreaksLoaded) return;
  window.__sneakQtyBreaksLoaded = true;

  function init() {
    var wrap = document.querySelector('[data-qty-breaks]');
    if (!wrap || wrap.dataset.qbReady) return;
    var formId = wrap.dataset.productForm;
    var form = document.getElementById(formId);
    if (!form) return;
    wrap.dataset.qbReady = '1';

    var cfgEl = document.querySelector('[data-qty-breaks-config]');
    var cfg = {};
    try { if (cfgEl) cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) {}

    var defaultTier = wrap.querySelector('[data-qb-tier].is-selected');
    var defaultVariantId = cfg.defaultVariantId;

    function formatPrice(cents) { return window.SneakMoney.format(cents, (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'); }

    /* Hide original buy buttons */
    var buyBtnsBlock = document.querySelector('.product-info__buy-buttons');
    if (buyBtnsBlock) buyBtnsBlock.style.display = 'none';

    /* Use our own ATC button */
    var atcBtn = wrap.querySelector('[data-qb-atc-btn]');
    var atcPriceEl = wrap.querySelector('[data-qb-atc-price]');

    /* Tier selection */
    wrap.addEventListener('click', function(e) {
      var tier = e.target.closest('[data-qb-tier]');
      if (!tier || e.target.closest('[data-qb-size-radio]') || e.target.closest('.block-swatch')) return;

      wrap.querySelectorAll('[data-qb-tier]').forEach(function(t) {
        t.classList.remove('is-selected');
        var sizes = t.querySelector('[data-qb-sizes]');
        if (sizes) sizes.style.display = 'none';
      });
      tier.classList.add('is-selected');

      var sizes = tier.querySelector('[data-qb-sizes]');
      if (sizes) sizes.style.display = '';

      /* Update ATC price */
      if (atcPriceEl) atcPriceEl.textContent = formatPrice(parseInt(tier.dataset.qbPrice, 10));
    });

    /* Option button active state */
    wrap.addEventListener('change', function(e) {
      if (!e.target.matches('[data-qb-option-radio]') && !e.target.matches('[data-qb-size-radio]')) return;
      var group = e.target.closest('.qty-breaks__size-options');
      if (!group) return;
      group.querySelectorAll('.block-swatch').forEach(function(b) {
        b.classList.toggle('is-active-qb', b.querySelector('input').checked);
      });
    });

    /* Variant lookup map: "option1/option2/..." → variant ID */
    var variantMap = cfg.variantMap || {};
    var optionCount = cfg.optionCount;

    function resolveVariant(unitContainer) {
      /* For single-option products using old data-qb-size-radio */
      var sizeRadio = unitContainer.querySelector('[data-qb-size-radio]:checked');
      if (sizeRadio) return parseInt(sizeRadio.value, 10);

      /* For multi-option products: collect selected option values */
      var optRadios = unitContainer.querySelectorAll('[data-qb-option-radio]:checked');
      if (optRadios.length === 0) return defaultVariantId;

      var values = [];
      /* Sort by option position */
      var sorted = Array.from(optRadios).sort(function(a, b) {
        return parseInt(a.dataset.qbOptionPos) - parseInt(b.dataset.qbOptionPos);
      });
      sorted.forEach(function(r) { values.push(r.value); });

      var key = values.join(' / ');
      return variantMap[key] || defaultVariantId;
    }

    /* ATC click */
    atcBtn.addEventListener('click', function() {
        var selectedTier = wrap.querySelector('[data-qb-tier].is-selected');
        if (!selectedTier) return;
        var qty = parseInt(selectedTier.dataset.qbQty, 10);

        /* Resolve selected variant from options */
        var sizeContainer = selectedTier.querySelector('[data-qb-sizes]');
        var vid = sizeContainer ? resolveVariant(sizeContainer) : defaultVariantId;
        var items = {};
        items[vid] = qty;

        var cartItems = [];
        for (var vid in items) {
          cartItems.push({ id: parseInt(vid, 10), quantity: items[vid] });
        }

        atcBtn.disabled = true;
        atcBtn.style.opacity = '0.6';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: cartItems })
        })
        .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function() {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var cartDrawer = document.getElementById('cart-drawer');
          if (cartDrawer && cartDrawer.show) cartDrawer.show();
        })
        .catch(function(err) { console.error('QtyBreaks ATC error', err); })
        .finally(function() { if (atcBtn) { atcBtn.disabled = false; atcBtn.style.opacity = ''; } });
      });
    }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }
  /* Re-init after Section Rendering API swaps (injected scripts don't run). */
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 100); });
})();
